hrd.utils.export.CSVExporter = hrd.utils.export.AbstractExporter.extend({
	init: function(tableManager, options) {
		var defaults = {
			impl: 'hrd.utils.export.CSVExporter'
		};
		this._super(tableManager, $.extend({}, defaults, options));
	},
	getExtension: function() {
		return 'csv';
	},
	getDataTypePrefix: function() {
		return "data:text/csv;charset=utf-8,";
	},
	exportHeader: function(columns) {
		let aHeader = columns
			.filter(col => this.exportableColumn(col))
			.map(col => this.getColumnTitle(col))
			.join(';');
		return aHeader + '\r\n';
	},
	exportRows: function(columns) {
		let rows = this.tableInstance.fnGetData();
		let aRows = rows.map(row => this.exportRow(row, columns)).join('\r\n');
		return aRows
	},
	exportRow: function(rowData, columns) {
		return columns
			.filter(columnInfo => this.exportableColumn(columnInfo))
			.map(columnInfo => this.extractValue(rowData, columnInfo))
			.join(';');
	}
});
